// Core
import { CSSProperties, ReactNode } from 'react';
// Packages
import { Divider as AntDivider } from 'antd';
// Styles
import './divider.styles.scss';

interface IDividerProps {
  className?: string;
  dashed?: boolean;
  orientation?: 'left' | 'right' | 'center';
  plain?: boolean;
  style?: CSSProperties;
  type?: 'horizontal' | 'vertical';
  children?: ReactNode;
}

/**
 * A divider line separates different content.
 *
 * @description Divide sections of article. Divide inline text and links such as the operation column of table.
 *
 * @param className - The className of container
 * @param dashed - Whether line is dashed
 * @param orientation - The position of title inside divider
 * @param plain - Divider text show as plain style
 * @param style - The style object of container
 * @param type - The direction type of divider
 * @param children - Some ReactNode
 */

const Divider = ({
  className,
  dashed = false,
  orientation = 'center',
  plain = true,
  style,
  type = 'horizontal',
  children,
}: IDividerProps) => (
  // antd 6 renamed the title position to `titlePlacement` and the line direction to `orientation`.
  <AntDivider
    className={className}
    dashed={dashed}
    titlePlacement={orientation}
    plain={plain}
    style={style}
    orientation={type}
  >
    {children}
  </AntDivider>
);

export default Divider;
